import {
  formatEventFeedbackTableMatchScore,
  getEventFeedbackHighlightLabel,
} from '../../constants/eventFeedbackHighlights';

const normalizeReviewStatus = (status) =>
  String(status || '')
    .trim()
    .toLowerCase();

export const EVENT_FEEDBACK_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  HIDDEN: 'hidden',
  DELETED: 'deleted',
};

export const normalizeEventReviewItem = (item) => {
  if (!item || typeof item !== 'object') {
    return null;
  }

  const reviewer = item.reviewer ?? {};
  const event = item.event ?? {};

  return {
    id: item.id ?? null,
    eventId: item.eventId ?? event.id ?? null,
    rating: Number(item.rating) || 0,
    comment: String(item.comment ?? '').trim(),
    status: normalizeReviewStatus(item.status),
    submittedAt: item.submittedAt ?? null,
    tableMatchScore: formatEventFeedbackTableMatchScore(item.tableMatchScore),
    highlight: getEventFeedbackHighlightLabel(item.highlight),
    fullName: reviewer.fullName ?? 'Unknown',
    role: reviewer.profession ?? '—',
    avatarUrl: reviewer.avatarUrl ?? null,
    eventTitle: event.title ?? null,
    eventDate: event.eventDate ?? null,
  };
};

export const mapEventReviewsResponse = (payload) => {
  const root = payload?.data ?? payload;
  const pending = (Array.isArray(root?.pending) ? root.pending : [])
    .map(normalizeEventReviewItem)
    .filter(Boolean);
  const approvedFromList = (Array.isArray(root?.approved) ? root.approved : [])
    .map(normalizeEventReviewItem)
    .filter(Boolean);
  const hiddenFromList = (Array.isArray(root?.hidden) ? root.hidden : [])
    .map(normalizeEventReviewItem)
    .filter(Boolean);

  const approvedById = new Map();
  [...approvedFromList, ...hiddenFromList].forEach((item) => {
    if (item?.id) {
      approvedById.set(item.id, item);
    }
  });
  const approved = Array.from(approvedById.values()).filter(
    (item) =>
      item.status === EVENT_FEEDBACK_STATUS.APPROVED ||
      item.status === EVENT_FEEDBACK_STATUS.HIDDEN,
  );

  return { pending, approved };
};

export const filterEventReviewsForEvent = (reviews, eventId) => {
  if (!eventId) {
    return reviews;
  }

  const normalizedEventId = String(eventId).trim();
  return reviews.filter((item) => String(item.eventId) === normalizedEventId);
};
